// eslint-disable

import React from "react";
import Content from "./Content";
import Tabs from "./Tabs";

export interface TabProps {
  route: string;
  name: string;
  // eslint-disable-next-line
  component: any;
}

type ContentStyle = "boxed_outlined" | "boxed_filled" | "";

interface NavTabsProps {
  tabs: Array<TabProps>;
  // eslint-disable-next-line
  match: any;
  contentStyle?: ContentStyle;
}

const NavTabs: React.FC<NavTabsProps> = ({ tabs, match: { path, url }, contentStyle = "" }: NavTabsProps): JSX.Element => {
  // set classes based on content style type
  let contentClass = "";
  let tabsClass = "";

  if (contentStyle === "boxed_outlined") {
    contentClass = "caprx-nav-tabs-content-outlined";
    tabsClass = "caprx-nav-tabs-list-no-border";
  }

  if (contentStyle === "boxed_filled") {
    contentClass = "caprx-nav-tabs-content-filled";
    tabsClass = "caprx-nav-tabs-list-no-border";
  }

  return (
    <div className="caprx-nav-tabs-container">
      <Tabs tabs={tabs} url={url} className={tabsClass} />
      <Content tabs={tabs} path={path} className={contentClass} />
    </div>
  );
};

export default NavTabs;
